import _ from 'lodash'

import { eventEmitter } from '@/event-bus'
import i18n from '@/i18n/i18n'
import OrderService from '@/services/admin/OrderService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

import { QueryBuilder } from '@/utilities/queryBuilder'

import { ORDER_WORKFLOW_JOBS, PAYMENT_STATUSES } from '@/constants/constants.js'
import { ORDER_ERROR_MESSAGES } from '@/constants/errorMessages'

import { ORDER_DOCUMENT_TYPE } from '@/constants/orderDocumentType'

const { t } = i18n.global

export const allowedFilters = [
  'farmer_payment_status',
  'retailer_payment_status',
  'farmer_payment_method',
  'retailer_id',
  'income_protected_sales',
  'application.company_id',
  'by_retailer_user',
  'farmer_id',
  'farmer_id_or_name',
  'created_between',
  'completed_between',
  'payment_date_between',
  'collection_date_between',
  'sales_channel',
  'workflow',
  'only_trashed',
  'payment_due_to_retailer_on_day',
  'by_financing_bank',
  'by_region',
  'by_farmer_city',
  'by_invoice',
  'invoice_date_between',
  'retailer_invoice_date_between',
  'collection_method',
  'is_income_protected_sale',
  'retailer.type',
  'by_sales_channel_convertation',
  'has_pending_document_control',
  'where_demo',
  'has_incompleted_process',
  'only_trashed',
  'product_category',
  'retailer_rank_group',
  'by_proceeding_type',
  'gts_status'
]

export const allowedIncludes = 'farmer,payments,retailer,application,application.dsPotentialFraud,payments.collections'

export const allowedExportIncludes = 'farmer,retailer,payments,payments.financingBank,payments.holderBank'

export const allowedSorts = '-created_at'

export const allowedAppends = ['confirm_legal_proceedings_began_workflow_status', 'sales_channel']

export const namespaced = true

export const state = {
  orders: null,
  order: {},
  order_sequence: null,
  order_payment_reminders: null,
  meta: null,
  invoice: null,
  promissory_note: null,
  scanned_promissory_note: null,
  scanned_income_protected_sale: null,
  sales_contract: null,
  transportation_document: null,
  repayment_schedule: null,
  credit_agreement: null,
  order_receipt: null,
  fibabanka_document: null,
  financing_bank_activities: [],
  invoice_pdf_url: null,
  supplementary_invoice_pdf_url: null,
  reversal_invoice_pdf_url: null,
  promissory_note_pdf_url: null,
  payment_notice_pdf_url: null,
  scanned_promissory_note_pdf_url: null,
  sales_contract_pdf_url: null,
  transportation_document_pdf_url: null,
  repayment_schedule_pdf_url: null,
  credit_agreement_pdf_url: null,
  mortgage_contract_pdf_url: null,
  late_fee_invoice_pdf_url: null,
  order_receipt_pdf_url: null,
  guarantor: null,
  retailerDeliveryWorkflowJobAnswers: [],
  scanned_promissory_note_versions: [],
  farmer_payment_information: null,
  payment_promises: []
}

export const mutations = {
  SET_ORDERS(state, orders) {
    state.orders = orders.data
    state.meta = orders.meta
  },
  SET_SCANNED_PROMISSORY_NOTE_VERSIONS(state, versions) {
    state.scanned_promissory_note_versions = versions
  },
  SET_ORDER(state, order) {
    state.order = order
  },
  SET_ORDER_SEQUENCE(state, sequence) {
    state.order_sequence = sequence
  },
  SET_ORDER_PAYMENT_REMINDERS(state, reminders) {
    state.order_payment_reminders = reminders
  },
  SET_PAYMENT_PROMISES(state, promises) {
    state.payment_promises = promises
  },
  DELETE_PAYMENT_PROMISE(state, paymentPromiseId) {
    state.payment_promises = _.filter(state.payment_promises, function (paymentPromise) {
      return paymentPromise.id !== paymentPromiseId
    })
  },
  SET_INVOICE(state, invoice) {
    state.invoice = invoice
  },
  SET_PROMISSORY_NOTE(state, promissory_notes) {
    state.promissory_note = promissory_notes.url
    state.scanned_promissory_note = promissory_notes.scanned_url
  },
  SET_SCANNED_INCOME_PROTECTED_SALE(state, scanned_income_protected_sale) {
    state.scanned_income_protected_sale = scanned_income_protected_sale
  },
  SET_SALES_CONTRACT(state, sales_contract) {
    state.sales_contract = sales_contract.url
  },
  SET_TRANSPORTATION_DOCUMENT(state, transportation_document) {
    state.transportation_document = transportation_document
  },
  SET_REPAYMENT_SCHEDULE(state, repayment_schedule) {
    state.repayment_schedule = repayment_schedule
  },
  SET_CREDIT_AGREEMENT(state, credit_agreement) {
    state.credit_agreement = credit_agreement
  },
  SET_ORDER_RECEIPT(state, order_receipt) {
    state.order_receipt = order_receipt
  },
  SET_FIBABANKA_DOCUMENT(state, fibabanka_document) {
    state.fibabanka_document = fibabanka_document
  },
  SET_DELETED(state, order) {
    state.order.deleted_at = order.deleted_at
    state.order.cancellation_reason = order.cancellation_reason.value
  },
  SET_FINANCING_BANK_ACTIVITIES(state, activities) {
    state.financing_bank_activities = activities.data
  },
  SET_INVOICE_PDF_URL(state, invoice) {
    state.invoice_pdf_url = invoice
  },
  SET_SUPPLEMENTARY_INVOICE_PDF_URL(state, supplementaryInvoice) {
    state.supplementary_invoice_pdf_url = supplementaryInvoice
  },
  SET_REVERSAL_INVOICE_PDF_URL(state, reversalInvoice) {
    state.reversal_invoice_pdf_url = reversalInvoice
  },
  SET_PROMISSORY_NOTE_PDF_URL(state, promissory_note) {
    state.promissory_note_pdf_url = promissory_note
  },
  SET_PAYMENT_NOTICE_PDF_URL(state, payment_notice) {
    state.payment_notice_pdf_url = payment_notice
  },
  SET_SCANNED_PROMISSORY_NOTE_PDF_URL(state, scanned_promissory_note) {
    state.scanned_promissory_note_pdf_url = scanned_promissory_note
  },
  SET_SALES_CONTRACT_PDF_URL(state, sales_contract) {
    state.sales_contract_pdf_url = sales_contract
  },
  SET_TRANSPORTATION_DOCUMENT_PDF_URL(state, transportation_document) {
    state.transportation_document_pdf_url = transportation_document
  },
  SET_REPAYMENT_SCHEDULE_PDF_URL(state, repayment_schedule_pdf_url) {
    state.repayment_schedule_pdf_url = repayment_schedule_pdf_url
  },
  SET_CREDIT_AGREEMENT_PDF_URL(state, credit_agreement_pdf_url) {
    state.credit_agreement_pdf_url = credit_agreement_pdf_url
  },
  SET_MORTGAGE_CONTRACT_PDF_URL(state, mortgage_contract) {
    state.mortgage_contract_pdf_url = mortgage_contract
  },
  SET_LATE_FEE_INVOICE_PDF_URL(state, lateFeeInvoice) {
    state.late_fee_invoice_pdf_url = lateFeeInvoice
  },
  SET_ORDER_RECEIPT_PDF_URL(state, order_receipt) {
    state.order_receipt_pdf_url = order_receipt
  },
  SET_RETAILER_INVOICE_NUMBER(state, data) {
    state.order.retailer_invoice_number = data.invoice_number
    state.order.retailer_invoice_date = data.invoice_date
  },
  SET_ORDER_ITEM_SUB_FIELDS(state, params) {
    state.order.items[params.index].sub = [
      {
        cash_unit_price_wo_kdv: params.sub.cash_unit_price_wo_kdv,
        forward_unit_price_wo_kdv: params.sub.forward_unit_price_wo_kdv,
        cash_unit_price: params.sub.cash_unit_price,
        forward_unit_price: params.sub.forward_unit_price,
        retailer_stock_outputs: params.sub.retailer_stock_outputs
      }
    ]
  },
  SET_GUARANTOR(state, guarantor) {
    state.guarantor = guarantor
  },
  SET_RETAILER_PAYMENT_STATUS(state, retailer_payment_status) {
    state.order.retailer_payment_status = retailer_payment_status
  },
  SET_RETAILER_WORKFLOW_JOB_ANSWERS(state, answers) {
    state.retailerDeliveryWorkflowJobAnswers = answers
  },
  SET_FARMER_PAYMENT_INFORMATION(state, farmerPaymentInformation) {
    state.farmer_payment_information = farmerPaymentInformation
  },
  SET_ORDER_DETAILS(state, details) {
    state.order.details = details
  }
}
export const getters = {
  getOrderId: state => id => {
    return state.orders ? state.orders.find(order => order.id === id) : false
  },
  orderExists: state => id => {
    if (state.orders) {
      return state.orders.find(order => order.id === id)
    }
    return false
  },
  getOrderRetailerPaymentStatus: state => id => {
    return state.orders ? state.orders.find(order => order.id === id).retailer_payment_status : false
  }
}

export const actions = {
  setOrderItemSubFields({ commit }, params) {
    commit('SET_ORDER_ITEM_SUB_FIELDS', params)
  },
  getOrders({ commit, dispatch }, query) {
    let newAllowedIncludes = allowedIncludes + ',logoInvoice'
    let newQuery = build_query(query, allowedFilters, newAllowedIncludes, allowedSorts, allowedAppends)

    return new Promise((resolve, reject) => {
      OrderService.getOrders(newQuery)
        .then(response => {
          commit('SET_ORDERS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getOrdersError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getOrder({ commit }, id) {
    return new Promise((resolve, reject) => {
      OrderService.getOrder(id)
        .then(response => {
          response.data.order_documents.filter(item => {
            if (item.type === ORDER_DOCUMENT_TYPE.SCANNED_INCOME_PROTECTED_SALE_CONTRACT) {
              commit('SET_SCANNED_INCOME_PROTECTED_SALE', item)
            }
          })
          commit('SET_ORDER', response.data)
          commit('SET_ORDER_SEQUENCE', response.meta.total)
          commit('SET_GUARANTOR', _.last(response.data.application.guarantors))
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getOrderPaymentReminders({ commit }, id) {
    return new Promise((resolve, reject) => {
      OrderService.getOrderPaymentReminders(id)
        .then(response => {
          commit('SET_ORDER_PAYMENT_REMINDERS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getInvoice({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      commit('SET_INVOICE', null)
      OrderService.getInvoice(id)
        .then(response => {
          commit('SET_INVOICE', response.data.url)
          resolve(response)
          eventEmitter.emit('order-documents-invoice-loading-end')
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getInvoiceError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
          eventEmitter.emit('order-documents-invoice-loading-end')
        })
    })
  },
  getPromissoryNote({ commit, dispatch }, id) {
    commit('SET_PROMISSORY_NOTE', { url: null, scanned_url: null })
    return new Promise((resolve, reject) => {
      OrderService.getPromissoryNote(id)
        .then(response => {
          commit('SET_PROMISSORY_NOTE', response.data)
          resolve(response)
          eventEmitter.emit('order-documents-promissory-note-loading-end')
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getPromissoryNoteError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
          eventEmitter.emit('order-documents-promissory-note-loading-end')
        })
    })
  },
  getSalesContract({ commit, dispatch }, id) {
    commit('SET_SALES_CONTRACT', { url: null, scanned_url: null })
    return new Promise((resolve, reject) => {
      OrderService.getSalesContract(id)
        .then(response => {
          commit('SET_SALES_CONTRACT', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getSalesContractError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getTransportationDocument({ commit, dispatch }, id) {
    commit('SET_TRANSPORTATION_DOCUMENT', null)
    return new Promise((resolve, reject) => {
      OrderService.getTransportationDocument(id)
        .then(response => {
          commit('SET_TRANSPORTATION_DOCUMENT', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getTransportationDocumentError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRepaymentSchedule({ commit, dispatch }, id) {
    commit('SET_REPAYMENT_SCHEDULE', null)
    return new Promise((resolve, reject) => {
      OrderService.getRepaymentSchedule(id)
        .then(response => {
          commit('SET_REPAYMENT_SCHEDULE', response.data)
          eventEmitter.emit('order-documents-repayment-schedule-loading-end')
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getRepaymentScheduleError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          eventEmitter.emit('order-documents-repayment-schedule-loading-end')
          reject(err)
        })
    })
  },
  getCreditAgreement({ commit, dispatch }, id) {
    commit('SET_CREDIT_AGREEMENT', null)
    return new Promise((resolve, reject) => {
      OrderService.getCreditAgreement(id)
        .then(response => {
          commit('SET_CREDIT_AGREEMENT', response.data)
          eventEmitter.emit('order-documents-credit-agreement-loading-end')
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getCreditAgreementError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          eventEmitter.emit('order-documents-credit-agreement-loading-end')
          reject(err)
        })
    })
  },
  getOrderReceipt({ commit, dispatch }, id) {
    commit('SET_ORDER_RECEIPT', null)
    return new Promise((resolve, reject) => {
      OrderService.getOrderReceipt(id)
        .then(response => {
          commit('SET_ORDER_RECEIPT', response.data)
          resolve(response)
          eventEmitter.emit('order-documents-receipt-loading-end')
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getOrderReceiptError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
          eventEmitter.emit('order-documents-receipt-loading-end')
        })
    })
  },
  getScannedPromissoryNoteVersions({ commit, dispatch }, id) {
    commit('SET_SCANNED_PROMISSORY_NOTE_VERSIONS', null)
    return new Promise((resolve, reject) => {
      OrderService.getScannedPromissoryNoteVersions(id)
        .then(response => {
          commit('SET_SCANNED_PROMISSORY_NOTE_VERSIONS', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getScannedPromissoryNoteVersions + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
        .finally(() => eventEmitter.emit('scannned-promissory-note-versions-loading-end'))
    })
  },
  getFibabankaDocument({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      OrderService.getFibabankaDocument(params.orderId, params.type)
        .then(response => {
          commit('SET_FIBABANKA_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getApplicableCrops({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      OrderService.getApplicableCrops()
        .then(response => {
          const data = response.data

          const staticOption = { id: 0, name: t('shared.common.not_exist') }
          const combinedData = [staticOption, ...data]

          resolve(combinedData)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  viewInvoice({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewInvoice(id)
        .then(response => {
          commit('SET_INVOICE_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          commit('SET_INVOICE_PDF_URL', null)
          if (err.response.status === 404) {
            resolve(err)
          } else {
            const notification = {
              type: 'danger',
              message: t('store.admin.order.view_invoice_error') + errorMessage(err)
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
          }
        })
    })
  },
  viewSupplementaryInvoice({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewSupplementaryInvoice(id)
        .then(response => {
          commit('SET_SUPPLEMENTARY_INVOICE_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          commit('SET_SUPPLEMENTARY_INVOICE_PDF_URL', null)
          if (err.response.status === 404) {
            resolve(err)
          } else {
            const notification = {
              type: 'danger',
              message: t('store.admin.order.view_supplementary_invoice_error') + errorMessage(err)
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
          }
        })
    })
  },
  viewReversalInvoice({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewReversalInvoice(id)
        .then(response => {
          commit('SET_REVERSAL_INVOICE_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          commit('SET_REVERSAL_INVOICE_PDF_URL', null)
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_reversal_invoice_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewLateFeeInvoice({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewLateFeeInvoice(id)
        .then(response => {
          commit('SET_LATE_FEE_INVOICE_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          commit('SET_LATE_FEE_INVOICE_PDF_URL', null)
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_late_fee_invoice_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewPromissoryNote({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewPromissoryNote(id)
        .then(response => {
          commit('SET_PROMISSORY_NOTE_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_promissory_note_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewPaymentNotice({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewPaymentNotice(id)
        .then(response => {
          commit('SET_PAYMENT_NOTICE_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_payment_noteice_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewScannedPromissoryNote({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      OrderService.viewScannedPromissoryNote(params.id, params.versionId)
        .then(response => {
          commit('SET_SCANNED_PROMISSORY_NOTE_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_scanned_promissory_note_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewSalesContract({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewSalesContract(id)
        .then(response => {
          commit('SET_SALES_CONTRACT_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_sales_contract') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewTransportationDocument({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewTransportationDocument(id)
        .then(response => {
          commit('SET_TRANSPORTATION_DOCUMENT_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_transportation_document') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewRepaymentSchedule({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewRepaymentSchedule(id)
        .then(response => {
          let blob = new Blob([response], { type: 'application/pdf' })
          commit('SET_REPAYMENT_SCHEDULE_PDF_URL', window.URL.createObjectURL(blob))
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_repayment_schedule') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewCreditAgreement({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewCreditAgreement(id)
        .then(response => {
          let blob = new Blob([response], { type: 'application/pdf' })
          commit('SET_CREDIT_AGREEMENT_PDF_URL', window.URL.createObjectURL(blob))
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_credit_agreement') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewOrderReceipt({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewOrderReceipt(id)
        .then(response => {
          commit('SET_ORDER_RECEIPT_PDF_URL', response)
          resolve(response)
        })
        .catch(err => {
          commit('SET_ORDER_RECEIPT_PDF_URL', null)
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_order_receipt_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportCollections({ dispatch }, query) {
    return new Promise(reject => {
      let newQuery = build_query(query, allowedFilters, allowedExportIncludes)

      OrderService.exportCollections(newQuery)
        .then(() => {
          const notification = {
            type: 'info',
            message: t('store.admin.order.export_collections_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.export_collections_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportAdministrativeProceedingCalls({ dispatch }, query) {
    return new Promise(reject => {
      let newQuery = build_query(query, allowedFilters, allowedExportIncludes)

      OrderService.exportAdministrativeProceedingCalls(newQuery)
        .then(() => {
          const notification = {
            type: 'info',
            message: t('store.admin.order.export_administrative_proceeding_calls_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.export_administrative_proceeding_calls_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportKit({ dispatch }, data) {
    return new Promise(reject => {
      let queryBuilder = new QueryBuilder(data.query)
      _.forEach(data.query, function (value, filter) {
        queryBuilder.where(filter, value)
      })
      let newQuery = queryBuilder.toString()

      OrderService.exportKit(newQuery, data.parameter)
        .then(() => {
          const notification = {
            type: 'info',
            message: t('store.shared.exporting', {
              element: data.label
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.export_kit_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportOrders({ dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedExportIncludes)

    return new Promise(reject => {
      OrderService.exportOrders(newQuery)
        .then(() => {
          const notification = {
            type: 'info',
            message: t('store.admin.order.export_orders_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.export_orders_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  generatePaymentOrderPdf({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      OrderService.generatePaymentOrderPdf(state.order.id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  generateReceiptOfDischarge({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      OrderService.generateReceiptOfDischarge(state.order.id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  generateCleanRefund({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      OrderService.generateCleanRefund(state.order.id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  generateFarmerTransportationPdf({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      OrderService.generateFarmerTransportationPdf(state.order.id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  generateIncomeProtectedSaleContract({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      OrderService.generateIncomeProtectedSaleContract(state.order.id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  downloadScannedIncomeProtectedSaleContract({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      OrderService.downloadScannedIncomeProtectedSaleContract(state.order.id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  delete({ dispatch, state, commit }, params) {
    return new Promise((resolve, reject) => {
      OrderService.destroy(state.order.id, params)
        .then(response => {
          let notification = {}

          if (response.data?.waitingApproval === undefined) {
            commit('SET_DELETED', response.data)
            notification = {
              type: 'warning',
              message: t('store.admin.order.delete_success')
            }
          } else {
            notification = {
              type: 'warning',
              message: t('store.shared.waiting_approval')
            }
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getFinancingBankActivities({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      OrderService.getFinancingBankActivities(id)
        .then(response => {
          commit('SET_FINANCING_BANK_ACTIVITIES', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.get_financial_bank_activities_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  saveRetailerInvoiceNumber({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      OrderService.saveRetailerInvoiceNumber(params.orderId, params.invoiceNumber, params.invoiceDate)
        .then(response => {
          commit('SET_RETAILER_INVOICE_NUMBER', {
            invoice_number: params.invoiceNumber,
            invoice_date: params.invoiceDate
          })

          const notification = {
            type: 'success',
            message: t('store.admin.order.save_retailer_invoice_number_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.save_retailer_invoice_number_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  removeScannedPromissoryNote({ dispatch, commit }, orderId) {
    return new Promise((resolve, reject) => {
      OrderService.removeScannedPromissoryNote(orderId)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order.remove_scanned_promissory_note_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.remove_scanned_promissory_note_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  removeScannedIncomeProtectedSaleContract({ dispatch, commit }, orderId) {
    return new Promise((resolve, reject) => {
      OrderService.removeScannedIncomeProtectedSaleContract(orderId)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order.remove_scanned_income_protected_sale_contract')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          commit('SET_SCANNED_INCOME_PROTECTED_SALE', null)

          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.remove_scanned_income_protected_sale_contract_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  toggleImportRetailerInvoiceInfoModal({ dispatch }) {
    eventEmitter.emit('toggle-import-retailer-invoice-info-modal-event')
  },
  toggleImportOrderLegalProceedingInfoModal({ dispatch }) {
    eventEmitter.emit('toggle-import-order-legal-proceeding-info-modal-event')
  },
  toggleImportLegalProceedingOrdersModal({ dispatch }) {
    eventEmitter.emit('toggle-import-legal-proceeding-orders-modal-event')
  },
  toggleImportGtsProductsModal({ dispatch }) {
    eventEmitter.emit('toggle-import-gts-products-modal-event')
  },
  updateAccountCollectionOrder({ dispatch, commit, state }, params) {
    return new Promise((resolve, reject) => {
      OrderService.updateAccountCollectionOrder(state.order.id, params)
        .then(response => {
          const notification = {
            type: 'success',
            message:
              params.account_collection_order === true
                ? t('store.admin.order.account_collection_order_completed')
                : t('store.admin.order.account_collection_order_cancelled')
          }

          dispatch('notification/add', notification, {
            root: true
          })

          commit('SET_ORDER_DETAILS', response.data.details)

          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.account_collection_order_failed')
          }

          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  sendPaymentReminderSms({ dispatch, state }) {
    return new Promise((resolve, reject) => {
      OrderService.sendPaymentReminderSms(state.order.id)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order.send_payment_reminder_sms_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.send_payment_reminder_sms_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  startImportRetailerInvoiceInfoProcess({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      OrderService.startImportRetailerInvoiceInfoProcess(form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order.start_import_retailer_invoice_info_process_started')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.start_import_retailer_invoice_info_process_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  startImportOrderLegalProceedingInfoProcess({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      OrderService.startImportOrderLegalProceedingInfoProcess(form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order.start_import_order_legal_proceeding_process_started')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.start_import_order_legal_proceeding_process_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  startImportLegalProceedingOrdersProcess({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      OrderService.startImportLegalProceedingOrdersProcess(form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order.start_import_legal_proceeding_orders_process_started')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.start_import_legal_proceeding_orders_process_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  startImportGtsProductsProcess({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      OrderService.startImportGtsProductsProcess(form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order.start_import_gts_products_process_started')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.start_import_gts_products_process_error') + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  toggleBlockingRetailerOrderPayment({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      OrderService.toggleBlockingRetailerOrderPayment(params.orderId)
        .then(response => {
          commit('SET_RETAILER_PAYMENT_STATUS', {
            retailer_payment_status: response.retailer_payment_status
          })

          let message = 'store.admin.order.set_retailer_payment_status_unblocked'
          if (response.retailer_payment_status === PAYMENT_STATUSES.BLOCKED) {
            message = 'store.admin.order.set_retailer_payment_status_blocked'
          }

          const notification = {
            type: 'success',
            message: t(message)
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.set_retailer_payment_status_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRetailerDeliveryWorkflowJobAnswers({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.getWorkflowJobAnswers(id, ORDER_WORKFLOW_JOBS.RETAILER_DELIVERY)
        .then(response => {
          commit('SET_RETAILER_WORKFLOW_JOB_ANSWERS', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: ORDER_ERROR_MESSAGES.getRetailerDeliveryWorkflowJobAnswers + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getFarmerPaymentInformation({ commit }, id) {
    return new Promise((resolve, reject) => {
      OrderService.getFarmerPaymentInformation(id)
        .then(response => {
          commit('SET_FARMER_PAYMENT_INFORMATION', response.data)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPaymentInfoByDate({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      OrderService.getPaymentInfoByDate(params.order_id, params.date, params.excluded_items)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createTransaction({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      OrderService.createTransaction(params.orderId, params.data)
        .then(response => {
          if (response.data?.waitingApproval === true){
            const notification = {
              type: 'warning',
              message: t('store.shared.waiting_approval')
            }

            dispatch('notification/add', notification, {
              root: true
            })
          }

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.create_transaction_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(true)
        })
    })
  },

  createManualTransaction({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      OrderService.createManualTransaction(params.orderId, params.data)
        .then(response => {
          if (response.data?.waitingApproval === true) {
            const notification = {
              type: 'warning',
              message: t('store.shared.waiting_approval')
            }

            dispatch('notification/add', notification, {
              root: true
            })
          }

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.create_transaction_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(true)
        })
    })
  },

  updateBulutTahsilatBankPaymentId({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      OrderService.updateBulutTahsilatBankPaymentId(params.orderId, params.transactionId, params.data)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('views.admin.orders.collection_info.bulut_tahsilat_bank_payment_updated')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.create_transaction_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(true)
        })
    })
  },

  getPaymentPromises({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      OrderService.getPaymentPromises(id)
        .then(response => {
          commit('SET_PAYMENT_PROMISES', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deletePaymentPromise({ dispatch, state, commit }, paymentPromiseId) {
    return new Promise((resolve, reject) => {
      OrderService.deletePaymentPromise(state.order.id, paymentPromiseId)
        .then(response => {
          commit('DELETE_PAYMENT_PROMISE', paymentPromiseId)
          const notification = {
            type: 'warning',
            message: t('store.admin.order.delete_payment_promise_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.error_while_deleting_payment_promise') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  viewMortgageContractItemDocument({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.viewMortgageContractItemDocument(id)
        .then(response => {
          let blob = new Blob([response], { type: 'application/pdf' })
          commit('SET_MORTGAGE_CONTRACT_PDF_URL', window.URL.createObjectURL(blob))
          resolve(response)
        })
        .catch(err => {
          commit('SET_MORTGAGE_CONTRACT_PDF_URL', null)
          const notification = {
            type: 'danger',
            message: t('store.admin.order.view_mortgage_contract') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  downloadMortgageContractItemDocument({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.downloadMortgageContractItemDocument(id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.order.download_mortgage_contract') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  sendPaymentLink({ dispatch }, orderId) {
    return new Promise((resolve, reject) => {
      OrderService.sendPaymentLink(orderId)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('views.retailer.orders.error_while_sending_sms') + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getTransactionHistory({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      OrderService.getTransactionHistory(id)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
